import { gql } from '@apollo/client';

export const SELLER_FIELDS = gql`
  fragment SellerFields on Seller {
    id
    name
    clientNumberLabel
    clientNumberLabelFull
    canAddAsset
  }
`;

export const UPDATE_CURRENT_SELLER = gql`
  ${SELLER_FIELDS}
  mutation UpdateCurrentSeller(
    $clientNumberLabel: String
  ) {
    updateCurrentSeller(
      clientNumberLabel: $clientNumberLabel
    ) {
      seller {
        ...SellerFields
      }
      errors { path, message }
    }
  }
`;
